var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChangeModal',{attrs:{"help":"HelpContactMe"}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Contact Us")])])
}
var staticRenderFns = []

export { render, staticRenderFns }